import React from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMapEvents, useMap } from 'react-leaflet';
import categoryIcons from '../utils/icons';

const MapEventHandlers = ({ 
  mapRef, 
  updateVisibleHotspots, 
  setFiltersVisible, 
  setFocusedHotspot,
  updateTimeoutRef 
}) => {
  const map = useMap();

  React.useEffect(() => {
    if (!mapRef.current) {
      mapRef.current = map;
      updateVisibleHotspots();
    }
  }, [map, updateVisibleHotspots, mapRef]);

  const debouncedUpdate = React.useCallback(() => {
    if (updateTimeoutRef.current) {
      clearTimeout(updateTimeoutRef.current);
    }
    updateTimeoutRef.current = setTimeout(() => {
      updateVisibleHotspots();
    }, 100);
  }, [updateVisibleHotspots, updateTimeoutRef]);

  useMapEvents({
    movestart: () => setFiltersVisible(false),
    moveend: debouncedUpdate,
    zoomend: debouncedUpdate,
    click: () => setFocusedHotspot(null)
  });

  return null;
};

const Map = ({ 
  filteredHotspots, 
  preloadedImages, 
  handleMarkerClick,
  handleLinkClick,
  mapRef,
  updateVisibleHotspots,
  setFiltersVisible,
  setFocusedHotspot,
  updateTimeoutRef,
  mobileView,
  setMobileView
}) => {
  return (
    <div className={`map-container ${mobileView === 'map' ? 'mobile-visible' : 'mobile-hidden'}`}>
      {mobileView === 'map' && (
        <button 
          className="mobile-view-toggle-button"
          onClick={() => setMobileView('list')}
        >
          Liste
        </button>
      )}
      <MapContainer center={[46.603354, 1.888334]} zoom={7} style={{ height: "100%", width: "100%" }} maxZoom={14}>
        <MapEventHandlers 
          mapRef={mapRef}
          updateVisibleHotspots={updateVisibleHotspots}
          setFiltersVisible={setFiltersVisible}
          setFocusedHotspot={setFocusedHotspot}
          updateTimeoutRef={updateTimeoutRef}
        />
        <TileLayer
          url="https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}.png?api_key=ba7698f9-a3f9-4e1d-8035-ec82c77a5c3f"
          attribution='&copy; <a href="https://geodrone3d.com/" target="_blank">Geo Drone 3D</a> | &copy; <a href="https://stadiamaps.com/" target="_blank">Stadia Maps</a>, &copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>'
          className="map-attribution"
        />
        {filteredHotspots.map((hotspot, index) => {
          const [lat, lng] = hotspot.location.split(',').map(Number);
          const iconKey = hotspot.category + (hotspot.visibility === 'public' ? 'P' : '');
          const imageUrl = preloadedImages[hotspot.name];

          return (
            <Marker 
              key={index} 
              position={[lat, lng]} 
              icon={categoryIcons[iconKey]}
              eventHandlers={{
                click: () => handleMarkerClick(hotspot)
              }}
            >
              <Popup>
                <div className="popup-content">
                  {imageUrl && <img src={imageUrl} alt={hotspot.name} className="popup-image" />}
                  <h2>{hotspot.name}</h2>
                  <p>{hotspot.description}</p>
                  {hotspot.link && (
                    <button onClick={() => handleLinkClick(hotspot.link)} className="popup-link">
                      Voir le projet
                    </button>
                  )}
                </div>
              </Popup>
            </Marker>
          );
        })}
      </MapContainer>
    </div>
  );
};

export default Map;